var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#26436E",
    fillRule: "nonzero",
    points: "4.298 19 4.298 13.665 9.641 13.665 9.641 11.86 4.298 11.86 4.298 7.796 10 7.796 10 6 2 6 2 19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26436E",
    fillRule: "nonzero",
    d: "M15.7648131,6 L16.1028259,6.00418909 C17.6524258,6.04328723 18.8129241,6.35607235 19.5843209,6.94254446 C20.4108174,7.57090743 20.8240656,8.51937984 20.8240656,9.7879617 C20.8240656,11.3327322 20.0377739,12.4535011 18.4651906,13.1502682 L18.2351869,13.246922 L22,19 L19.5205105,19 L16.3299909,13.8071135 L14.1786691,13.8071135 L14.1786691,19 L12,19 L12,6 L15.7648131,6 Z M15.6189608,7.79616963 L14.1786691,7.79616963 L14.1786691,12.0465116 L15.691887,12.0465116 C16.7067761,12.0465116 17.4421149,11.8627451 17.8979034,11.495212 C18.3536919,11.127679 18.5815861,10.5823073 18.5815861,9.85909713 C18.5815861,9.12403101 18.3354603,8.59644323 17.8432088,8.27633379 C17.4001823,7.98823529 16.7553327,7.82978112 15.90866,7.80097127 L15.6189608,7.79616963 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrench);
export default __webpack_public_path__ + "static/media/french.95014732e657a0cebb85b6e242109abc.svg";
export { ForwardRef as ReactComponent };